import { Edit } from '@mui/icons-material'
import { IconButton, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { UsuariosContext } from '../../pages/catalogos/UsuariosPage'

export const TablaUsuarioComponent = ({usuario}) => {
  const {setUsuarioSeleccionado, setModalAgregaUsuario} = useContext(UsuariosContext);

  const editarUsuario = async() => {
    await setUsuarioSeleccionado(usuario);
    setModalAgregaUsuario(true);
  }

  return (
    <>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}} >{usuario.Usuario}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.Nombre}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.ApellidoPaterno}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.ApellidoMaterno}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.TelefonoCelular}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.TelefonoOficina}</Typography>
        <Typography style={{fontSize:12, fontWeight:'',flex:15}}>{usuario.descripcion}</Typography>
        <div><IconButton onClick={() => {editarUsuario()}}><Edit style={{color:"green", fontSize:15}} /></IconButton></div>
    </>
  )
}
